import { useEffect, useState } from 'react';
import * as api from '../../../api';
import styled from 'styled-components';
import Spinner from '../../../Plateforme/Atoms/Spinner';
import { Link, useSearchParams } from 'react-router-dom';
import FabFrIndicator from '../../Atoms/FabFrIndicator';
import * as XLSX from 'xlsx';
import { FD100MultiSelectOptions } from '../../Utils/Listings';
import { supabase } from '../../../lib/supabaseClient';
import JSZip from 'jszip';

// Winning project IDs for FD100 2025
const WINNER_PROJECT_IDS = [
    '67a332e21b103d938bafb0dc', '67a0b8331b103d938bafa954', '67aa1011740d844a3d633e93',
    '6829daa5754f51df2ef9141c', '67e6c18043d5609350e381a8', '67b5e6146890f1a147192905',
    '67be4a58b1ba28c3144aeb73', '67bf2330b1ba28c3144af8d2', '67c090dcdb48cb16a13c5b43',
    '677268097ec5d90c89d6fe63', '67c6b416db48cb16a13c73c7', '67ab652c07736060460b3b75',
    '68348986754f51df2ef9b87c', '67d15108d95ccf24eaf191df', '67d7d38c43d5609350e242a1',
    '67d82d2243d5609350e24c5e', '662adc507159e5b1b1da7c75', '67d8718c43d5609350e25c38',
    '67d1977243d5609350e218f2', '682b5c5f754f51df2ef93bbc', '67da910a43d5609350e274d7',
    '67e1864b43d5609350e2baeb', '67daebf343d5609350e27a9e', '67dd585043d5609350e28e57',
    '67dfeb0e43d5609350e2a360', '67e1452a43d5609350e2b066', '678675e2de3ed4a7001ab532',
    '67e2d05943d5609350e2cf97', '67e3e1cb43d5609350e304e5', '67e3e81543d5609350e308de',
    '67e3f02643d5609350e30a0a', '67e42d7043d5609350e32539', '67e42e5543d5609350e32570',
    '67e45c9843d5609350e329c0', '67e529f743d5609350e33a8c', '67e53aab43d5609350e340c3',
    '67e56ab043d5609350e3490f', '67e5764d43d5609350e34cb5', '67e57f5143d5609350e3519a',
    '67e5864c43d5609350e353a3', '67e58da443d5609350e3561d', '67e58ebc43d5609350e35665',
    '67e5ab6b43d5609350e35905', '67e6828d43d5609350e36b6a', '67e6acaf43d5609350e37832',
    '67e51ddb43d5609350e33667', '67e6c0a843d5609350e380cf', '67e6d53a43d5609350e38725',
    '67e6dfff43d5609350e38900', '67e7003c43d5609350e38bfc', '6834625c754f51df2ef9a4b1',
    '67ea99b76b7945ed1a576bae', '67f90250a0262e085d37088f', '67e1741a43d5609350e2b608',
    '67fe7a6c9167c049fff4e37e', '67ab6ade07736060460b3c16', '6810a343264e7745556acae1',
    '6800f4c59167c049fff51f5d', '6800b8529167c049fff50e47', '6800e76e9167c049fff5197f',
    '6800ef849167c049fff51c6f', '6800fad59167c049fff52224', '680113739167c049fff52d73',
    '680106139167c049fff525af', '680125219167c049fff53405', '680957ab9167c049fff5a7c2',
    '681164d36c8fbfe5e3c91e9e', '68020ef79167c049fff54015', '68025d069167c049fff56132',
    '680b728c9167c049fff5c8f7', '680249249167c049fff55a19', '68024ed89167c049fff55b90',
    '68025b1a9167c049fff56037', '680270379167c049fff566f5', '680274c09167c049fff567c8',
    '680275419167c049fff567de', '68027b389167c049fff56954', '680291609167c049fff56cad',
    '6802a3fc9167c049fff56f5f', '6849787b17dde4ca4c4bf043', '6849435a17dde4ca4c4be251',
    '6807cb759167c049fff58dd4', '6808c3f59167c049fff599c7', '6808c3859167c049fff599b1',
    '680fa4b19167c049fff5deee', '6801e2f49167c049fff53ce1', '680a54a09167c049fff5bbc4',
    '680b94b29167c049fff5cd49', '6810df4a264e7745556ad75d', '680fa3f89167c049fff5deb1',
    '680fa844a71ddf126b77b977', '680fa9f09167c049fff5e027', '6810c9b9264e7745556acf4d',
    '681125b66c8fbfe5e3c91c62', '6818cac19e656d77bc6c72fa', '6818d27e9e656d77bc6c75a3',
    '6818dbdf9e656d77bc6c78a0', '682d97b2754f51df2ef96070', '67fccffaa0262e085d370ddc',
    '680271809167c049fff5674a'
];

const Container = styled.div`
    max-width: 1400px;
    margin: 0 auto;
    padding: 20px;
`;

const HeaderSection = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 20px 0 30px 0;
    padding: 20px;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-radius: 12px;
    border: 1px solid #dee2e6;
`;

const StatsInfo = styled.div`
    font-size: 16px;
    color: #555;
    font-weight: 600;
    text-align: center;
    
    .main-title {
        font-size: 24px;
        color: #2196f3;
        font-weight: 700;
        margin-bottom: 10px;
    }
    
    .event-info {
        font-size: 18px;
        color: #333;
        margin-bottom: 15px;
    }
    
    .selection-date {
        font-size: 14px;
        color: #666;
        font-style: italic;
    }
`;

const ExportButton = styled.button`
    padding: 10px 20px;
    background: linear-gradient(135deg, #4caf50, #45a049);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
    display: flex;
    align-items: center;
    gap: 8px;
    
    &:hover {
        background: linear-gradient(135deg, #45a049, #388e3c);
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(76, 175, 80, 0.3);
    }
    
    &:active {
        transform: translateY(0);
    }
`;

const BackButton = styled(Link)`
    display: inline-flex;
    align-items: center;
    gap: 8px;
    padding: 12px 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white !important;
    text-decoration: none;
    border-radius: 8px;
    font-weight: 600;
    transition: all 0.3s ease;
    margin-bottom: 20px;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
    
    &:hover {
        background: linear-gradient(135deg, #1976d2, #1565c0);
        color: white !important;
        transform: translateX(-2px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }
`;

const SectionTitle = styled.h3`
    font-size: 20px;
    font-weight: 700;
    margin: 30px 0 20px 0;
    padding: 15px 20px;
    background: ${props => props.background || 'linear-gradient(135deg, #2196f3, #1976d2)'};
    color: white;
    border-radius: 8px;
    text-align: center;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
`;

const ProjectGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(350px, 1fr));
    gap: 25px;
    margin-bottom: 40px;
    padding: 20px 10px; // Add padding to ensure badges are not cropped
`;

const ProjectCard = styled.div`
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    padding: 24px;
    background: white;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: visible; // Changed from hidden to visible to show badges
    
    &:hover {
        box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
        transform: translateY(-2px);
        border-color: #2196f3;
    }
`;

const ProjectImage = styled.div`
    width: 100%;
    height: 220px;
    background-size: cover;
    background-position: center;
    background-color: #f8f9fa;
    border-radius: 8px;
    margin-bottom: 18px;
    border: 1px solid #eee;
`;

const ProjectName = styled.h3`
    margin: 0 0 12px 0;
    font-size: 20px;
    font-weight: 700;
    color: #1a1a1a;
    line-height: 1.3;
    display: flex;
    align-items: center;
    gap: 8px;
`;

const DesignerName = styled.p`
    margin: 0 0 16px 0;
    color: #666;
    font-size: 15px;
    font-weight: 500;
`;

const CategoryBadge = styled.span`
    display: inline-block;
    padding: 6px 12px;
    background: linear-gradient(135deg, #e3f2fd, #bbdefb);
    border: 1px solid #2196f3;
    color: #1976d2;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    margin-bottom: 12px;
`;

const RatingsInfo = styled.div`
    display: flex;
    justify-content: space-between;
    margin: 16px 0;
    padding: 16px;
    background: linear-gradient(135deg, #f8f9fa, #e9ecef);
    border-radius: 8px;
    border: 1px solid #dee2e6;
    font-size: 12px;
`;

const RatingItem = styled.div`
    text-align: center;
    
    .label {
        font-weight: 700;
        color: #555;
        font-size: 11px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
        margin-bottom: 4px;
    }
    
    .value {
        font-size: 20px;
        font-weight: 800;
        color: #2196f3;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
    }
`;

const ViewButton = styled(Link)`
    display: inline-block;
    padding: 12px 20px;
    background: linear-gradient(135deg, #2196f3, #1976d2);
    color: white;
    text-decoration: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    text-align: center;
    transition: all 0.3s ease;
    box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
    margin-right: 10px;
    margin-bottom: 10px;
    
    &:hover {
        background: linear-gradient(135deg, #1976d2, #1565c0);
        color: white;
        transform: translateY(-1px);
        box-shadow: 0 4px 12px rgba(33, 150, 243, 0.4);
    }
`;

const RankingBadge = styled.div`
    position: absolute;
    top: -12px;
    right: -12px;
    background: ${props => {
        if (props.rank <= 10) return 'linear-gradient(135deg, #ffd700, #ffb300)'; // Gold for top 10
        if (props.rank <= 50) return 'linear-gradient(135deg, #c0c0c0, #999999)'; // Silver for top 50
        if (props.rank <= 91) return 'linear-gradient(135deg, #cd7f32, #b87333)'; // Bronze for top 91
        return 'linear-gradient(135deg, #ff6b35, #f7931e)'; // Orange for ballotage
    }};
    color: white;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 800;
    font-size: 14px;
    box-shadow: 0 2px 8px ${props => {
        if (props.rank <= 10) return 'rgba(255, 215, 0, 0.5)';
        if (props.rank <= 50) return 'rgba(192, 192, 192, 0.5)';
        if (props.rank <= 91) return 'rgba(205, 127, 50, 0.5)';
        return 'rgba(255, 107, 53, 0.4)';
    }};
    border: 2px solid ${props => {
        if (props.rank <= 10) return '#ffb300';
        if (props.rank <= 50) return '#808080';
        if (props.rank <= 91) return '#a0522d';
        return '#e85d2a';
    }};
    z-index: 10;
`;

const BallotageLabel = styled.div`
    position: absolute;
    top: 10px;
    left: 10px;
    padding: 6px 12px;
    background: linear-gradient(135deg, #ff9800, #f57c00);
    color: white;
    border-radius: 20px;
    font-size: 12px;
    font-weight: 600;
    z-index: 10;
    box-shadow: 0 2px 8px rgba(255, 152, 0, 0.4);
`;

const NoSelectionMessage = styled.div`
    text-align: center;
    padding: 60px 20px;
    background: #f8f9fa;
    border: 2px dashed #dee2e6;
    border-radius: 12px;
    margin: 40px 0;
    
    h3 {
        color: #6c757d;
        margin-bottom: 15px;
        font-size: 24px;
    }
    
    p {
        color: #868e96;
        font-size: 16px;
        margin-bottom: 20px;
        line-height: 1.5;
    }
`;

const FD100FinalSelection = () => {
    const [searchParams] = useSearchParams();
    const [event, setEvent] = useState(null);
    const [selection, setSelection] = useState(null);
    const [loading, setLoading] = useState(true);
    const [ratings, setRatings] = useState([]);
    const [generatingPDF, setGeneratingPDF] = useState(false);
    const [downloadingImages, setDownloadingImages] = useState(false);
    const [downloadingAllImages, setDownloadingAllImages] = useState(false);
    const [downloadingImagesWithCredits, setDownloadingImagesWithCredits] = useState(false);
    const [editedDataMap, setEditedDataMap] = useState({});
    const [definitiveNames, setDefinitiveNames] = useState({});

    useEffect(() => {
        const eventIdFromParam = searchParams.get("eid");
        if (eventIdFromParam) {
            api.getEventById({ id: eventIdFromParam }).then((response) => {
                setEvent(response.data);
            }).catch((error) => {
                console.log(error);
            });
        } else {
            setLoading(false);
        }
    }, [searchParams]);

    // Load winner projects from API using WINNER_PROJECT_IDS (same as FD100SuiviLaureats)
    useEffect(() => {
        if (!event) return;

        api.getParticipatingUsersProjectData({ eventId: event._id, winnerProjectIds: WINNER_PROJECT_IDS, fullProjectData: true }).then(async (response) => {
            console.log("FD100FinalSelection - API response:", response.data);
            let _allProjects = [];
            response.data.forEach(user => {
                if (user.participation.data.projets) {
                    user.participation.data.projets.forEach(project_id => {
                        const project = user.company.projects.find((projet) => projet._id === project_id);
                        if (project && project.status === "validé" && WINNER_PROJECT_IDS.includes(project._id)) {
                            _allProjects.push({
                                projet: { ...project, participationId: user.participation._id },
                                user: user
                            });
                        }
                    });
                }
            });

            console.log("FD100FinalSelection - Winner projects found:", _allProjects.length);

            if (_allProjects.length > 0) {
                const selectionData = {
                    top91: _allProjects,
                    ballotage9: [],
                    eventId: event._id,
                    eventTitle: event.title_fr,
                    date: new Date().toISOString()
                };

                // Create selection from winner projects
                setSelection(selectionData);

                // Backup to Supabase
                try {
                    const { error } = await supabase
                        .from('fd100_final_selection')
                        .upsert({
                            event_id: event._id,
                            event_title: event.title_fr,
                            top91: _allProjects,
                            ballotage9: [],
                            updated_at: new Date().toISOString()
                        }, { onConflict: 'event_id' });

                    if (error) {
                        console.error('Error backing up to Supabase:', error);
                    } else {
                        console.log('FD100 Final Selection backed up to Supabase successfully');
                    }
                } catch (err) {
                    console.error('Supabase backup error:', err);
                }
            }
            setLoading(false);
        }).catch((error) => {
            console.log(error);
            setLoading(false);
        });
    }, [event]);

    useEffect(() => {
        if (!event) return;
        api.getAllJuriesForEvent({ eventId: event._id }).then((response) => {
            let _allJuries = response.data.sort((a,b) => a.last_name.localeCompare(b.last_name));
            let _ratings = [];
            _allJuries.forEach(jury => {
                if (jury.juryNotes) {
                    jury.juryNotes.forEach(rating => {
                        rating.jury = jury;
                        let _projetIndex = _ratings.findIndex(r => r.id === rating.participationId + rating.projetId);
                        if (_projetIndex === -1) {
                            _ratings.push({id : rating.participationId + rating.projetId, ratings : [{rating}]});
                        } else {
                            _ratings[_projetIndex].ratings.push({rating});
                        }
                    });
                }
            });
            setRatings(_ratings);
        }).catch((error) => {
            console.log(error);
        });
    }, [event]);

    // Fetch edited data from Supabase for display consistency with Excel export
    useEffect(() => {
        if (!selection) return;

        const fetchEditedData = async () => {
            const projectIds = [...selection.top91, ...selection.ballotage9].map(p => p.projet._id);

            try {
                const { data: trackingData, error } = await supabase
                    .from('fd100_laureats_tracking')
                    .select('project_id, edited_project_name, edited_creator_name, edited_country, edited_fabricants')
                    .in('project_id', projectIds);

                if (!error && trackingData) {
                    const dataMap = {};
                    trackingData.forEach(record => {
                        dataMap[record.project_id] = {
                            projectName: record.edited_project_name,
                            creatorName: record.edited_creator_name,
                            country: record.edited_country,
                            fabricants: record.edited_fabricants
                        };
                    });
                    setEditedDataMap(dataMap);
                }
            } catch (err) {
                console.error('Error fetching edited data from Supabase:', err);
            }
        };

        fetchEditedData();
    }, [selection]);

    // Fetch definitive names from Supabase (same source as VoteFD100Page)
    useEffect(() => {
        if (!event) return;
        supabase
            .from('fd100_project_names')
            .select('project_id, designer_definitive')
            .eq('event_id', event._id)
            .then(({ data, error }) => {
                if (!error && data) {
                    const map = {};
                    data.forEach(item => { map[item.project_id] = item.designer_definitive; });
                    setDefinitiveNames(map);
                }
            });
    }, [event]);

    // Helper to get display name (edited or original) - matches Excel export logic
    const getDisplayProjectName = (project) => {
        const edits = editedDataMap[project.projet._id];
        // Use edited project name if available, otherwise use name_en or name (same as Excel export)
        return edits?.projectName || project.projet.name_en || project.projet.name;
    };

    // Helper to get display creator name (edited or original)
    // Fallback chain: Supabase edited name → override_designer_name → Supabase definitive name → user first/last name
    const getDisplayCreatorName = (project) => {
        const edits = editedDataMap[project.projet._id];
        if (edits?.creatorName) return edits.creatorName.toUpperCase();
        if (project.projet.override_designer_name) return project.projet.override_designer_name.toUpperCase();
        const definitive = definitiveNames[project.projet._id];
        if (definitive) return definitive.toUpperCase();
        // Last resort: use MongoDB user first/last name for person candidates
        if (project.projet.candidate_as_person_fd100_25 === "oui") {
            const firstName = project.user.user?.first_name || '';
            const lastName = project.user.user?.last_name || '';
            return `${firstName} ${lastName}`.trim().toUpperCase();
        }
        return '';
    };

    const getProjectImage = (project) => {
        if (project.medias && project.medias.length > 0) {
            const firstMedia = project.medias[0];
            if (firstMedia.type.includes('image')) {
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + firstMedia.path;
            } else if (firstMedia.type.includes('pdf')) {
                const filename = firstMedia.path.split('/').pop();
                const pdfPreviewPath = firstMedia.path.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + pdfPreviewPath;
            }
        }
        return null;
    };

    const getProjectRatings = (project) => {
        return ratings.find(rating => rating.id === project.projet.participationId + project.projet._id)?.ratings || [];
    };

    const cumulNoteOfProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((totalStars, rating) => totalStars + (rating.rating.stars || 0), 0);
    };

    const cumulMentionsForProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.Coup_de_coeur === "checked" ? 1 : 0), 0);
    };

    const commentairesForProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.commentaire ? 1 : 0), 0);
    };

    const departagePointsForProj = (project) => {
        const _ratings = getProjectRatings(project);
        return _ratings.reduce((total, rating) => total + (rating.rating.departagePoints || 0), 0);
    };

    const hasFabricationFrancaise = (project) => {
        return project.projet.fabrication_fr === "oui";
    };

    // Get country from project address (for espace type projects)
    const getProjectCountry = (project) => {
        if (!project.projet.adresse) return '';
        const addressParts = project.projet.adresse.split(',');
        const country = addressParts.length > 0 ? addressParts[addressParts.length - 1].trim() : '';
        // Remove any numbers from country name
        const countryClean = country.replace(/[0-9]/g, '').trim();
        // Translate common French country names to English
        const countryTranslations = {
            'japon': 'Japan',
            'espagne': 'Spain',
            'france': 'France',
            'allemagne': 'Germany',
            'italie': 'Italy',
            'royaume-uni': 'United Kingdom',
            'états-unis': 'United States',
            'etats-unis': 'United States',
            'chine': 'China',
            'belgique': 'Belgium',
            'suisse': 'Switzerland',
            'pays-bas': 'Netherlands'
        };
        return countryTranslations[countryClean.toLowerCase()] || countryClean;
    };

    // Sanitize filename to remove invalid characters
    const sanitizeFilename = (name) => {
        return name
            .replace(/[<>:"/\\|?*]/g, '') // Remove invalid chars
            .replace(/\s+/g, '_') // Replace spaces with underscores
            .substring(0, 200); // Limit length
    };

    // Get the original high-resolution image URL (not the thumbnail)
    const getProjectImageHighRes = (project) => {
        if (project.medias && project.medias.length > 0) {
            const firstMedia = project.medias[0];
            if (firstMedia.type.includes('image')) {
                // Return full resolution image URL with fullsize parameter to bypass compression
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + firstMedia.path + "?fullsize=true";
            } else if (firstMedia.type.includes('pdf')) {
                // For PDFs, return the first page preview with fullsize parameter
                const filename = firstMedia.path.split('/').pop();
                const pdfPreviewPath = firstMedia.path.replace(filename, "firstpage_" + filename).replace('.pdf', '.png');
                return process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + pdfPreviewPath + "?fullsize=true";
            }
        }
        return null;
    };

    // Get all image URLs for a project (high resolution, images only)
    const getAllProjectImagesHighRes = (project) => {
        const images = [];
        if (project.medias && project.medias.length > 0) {
            project.medias.forEach(media => {
                if (media.type.includes('image')) {
                    images.push({
                        url: process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + media.path + "?fullsize=true",
                        originalName: media.path.split('/').pop()
                    });
                }
            });
        }
        return images;
    };

    // Download first image (thumbnail) for each project as a ZIP file (server-side)
    const downloadAllImages = async () => {
        if (!selection) return;

        setDownloadingImages(true);

        try {
            // Combine all projects
            const allProjects = [
                ...selection.top91,
                ...selection.ballotage9
            ];

            // Prepare data for server
            const projectsData = allProjects.map(project => {
                const imageUrl = getProjectImageHighRes(project.projet);
                const creatorName = getDisplayCreatorName(project);
                const projectName = project.projet.name_en || project.projet.name;

                // Get extension from URL
                let extension = 'jpg';
                if (imageUrl && imageUrl.includes('.png')) extension = 'png';
                else if (imageUrl && imageUrl.includes('.gif')) extension = 'gif';
                else if (imageUrl && imageUrl.includes('.webp')) extension = 'webp';

                return {
                    folderName: sanitizeFilename(projectName),
                    images: imageUrl ? [{
                        url: imageUrl,
                        originalName: sanitizeFilename(`${projectName} - ${creatorName}`) + `.${extension}`
                    }] : []
                };
            }).filter(p => p.images.length > 0);

            console.log(`Sending ${projectsData.length} projects to server for ZIP creation`);

            // Call server API
            const response = await api.downloadFD100ImagesZip(projectsData, false);

            // Create download link from blob response
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `FD100_2025_Thumbnails_${new Date().toISOString().split('T')[0]}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error creating ZIP:', error);
            alert('Erreur lors de la création du fichier ZIP');
        } finally {
            setDownloadingImages(false);
        }
    };

    // Download ALL images for each project, organized in folders (server-side)
    const downloadAllImagesComplete = async () => {
        if (!selection) return;

        setDownloadingAllImages(true);

        try {
            // Combine all projects
            const allProjects = [
                ...selection.top91,
                ...selection.ballotage9
            ];

            // Prepare data for server - all images per project
            const projectsData = allProjects.map(project => {
                const images = getAllProjectImagesHighRes(project.projet);
                const projectName = project.projet.name_en || project.projet.name;

                return {
                    folderName: sanitizeFilename(projectName),
                    images: images
                };
            }).filter(p => p.images.length > 0);

            // Count total images for display
            const totalImages = projectsData.reduce((sum, p) => sum + p.images.length, 0);
            console.log(`Sending ${projectsData.length} projects (${totalImages} images) to server for ZIP creation`);

            // Call server API
            const response = await api.downloadFD100ImagesZip(projectsData, true);

            // Create download link from blob response
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `FD100_2025_All_Images_${new Date().toISOString().split('T')[0]}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error creating ZIP:', error);
            alert('Erreur lors de la création du fichier ZIP');
        } finally {
            setDownloadingAllImages(false);
        }
    };

    // Download thumbnails with credits in filename + credits text file (frontend-only using JSZip)
    const downloadImagesWithCredits = async () => {
        if (!selection) return;

        setDownloadingImagesWithCredits(true);

        try {
            // Get sorted projects in final selection order
            const sortedBallotage = [...(selection.ballotage9 || [])].sort((a, b) => {
                const noteA = cumulNoteOfProj(a);
                const noteB = cumulNoteOfProj(b);
                if (noteB !== noteA) return noteB - noteA;
                const coeurA = cumulMentionsForProj(a);
                const coeurB = cumulMentionsForProj(b);
                if (coeurB !== coeurA) return coeurB - coeurA;
                return 0;
            });

            // Combine all projects in order: sorted top91 first, then sorted ballotage
            const allProjectsOrdered = [
                ...sortedTop91,
                ...sortedBallotage
            ];

            const zip = new JSZip();

            // Prepare credits text content
            let creditsTextContent = 'FD100 2025 - Crédits Photos\n';
            creditsTextContent += '================================\n\n';

            // Process each project
            let successCount = 0;
            for (let index = 0; index < allProjectsOrdered.length; index++) {
                const project = allProjectsOrdered[index];
                const rank = index + 1;
                const rankStr = String(rank).padStart(2, '0');
                const projectName = project.projet.name_en || project.projet.name;

                // Get first image and its credit
                const firstMedia = project.projet.medias?.find(m => m.type?.includes('image'));
                const credit = firstMedia?.credit || 'No credit';

                // Add to credits text file
                creditsTextContent += `#${rank} - ${projectName}: ${credit}\n`;

                if (!firstMedia) {
                    console.log(`No image for project #${rank}: ${projectName}`);
                    continue;
                }

                const imageUrl = process.env.REACT_APP_MEDIA_BASE_URL + "userfiles/" + firstMedia.path;

                // Get extension from path
                let extension = 'jpg';
                if (firstMedia.path?.includes('.png')) extension = 'png';
                else if (firstMedia.path?.includes('.gif')) extension = 'gif';
                else if (firstMedia.path?.includes('.webp')) extension = 'webp';

                // Filename: 01_ProjectTitle_Credit.jpg
                const filename = sanitizeFilename(`${rankStr}_${projectName}_${credit}`) + `.${extension}`;

                try {
                    // Fetch image as blob
                    const response = await fetch(imageUrl);
                    if (response.ok) {
                        const blob = await response.blob();
                        zip.file(filename, blob);
                        successCount++;
                        console.log(`Added ${successCount}/${allProjectsOrdered.length}: ${filename}`);
                    } else {
                        console.error(`Failed to fetch image for project #${rank}: ${response.status}`);
                    }
                } catch (err) {
                    console.error(`Error fetching image for project #${rank}:`, err);
                }
            }

            // Add credits text file to ZIP
            zip.file('FD100_2025_Credits.txt', creditsTextContent);

            console.log(`ZIP creation complete: ${successCount} images added`);

            // Generate ZIP and download
            const content = await zip.generateAsync({ type: 'blob' });
            const url = window.URL.createObjectURL(content);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `FD100_2025_Images_With_Credits_${new Date().toISOString().split('T')[0]}.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error creating ZIP with credits:', error);
            alert('Erreur lors de la création du fichier ZIP');
        } finally {
            setDownloadingImagesWithCredits(false);
        }
    };

    const exportToExcel = () => {
        if (!selection) return;

        // Combine all 100 projects in order (use sortedTop91 for correct order)
        const allProjects = [
            ...sortedTop91.map((project, index) => ({ ...project, finalRank: index + 1 })),
            ...selection.ballotage9.map((project, index) => ({ ...project, finalRank: sortedTop91.length + index + 1 }))
        ];

        // Helper to get fabricants list
        const getFabricantsList = (project, edits) => {
            // Use edited fabricants if available
            if (edits.fabricants) {
                try {
                    const parsed = JSON.parse(edits.fabricants);
                    if (Array.isArray(parsed)) {
                        return parsed.map(f => typeof f === 'object' ? f.name : f).join(', ');
                    }
                } catch {}
            }
            // Otherwise use original fabricants from project
            if (project.projet.fabricants) {
                try {
                    const parsed = JSON.parse(project.projet.fabricants);
                    if (Array.isArray(parsed)) {
                        return parsed.map(f => typeof f === 'object' ? f.name : f).join(', ');
                    }
                } catch {}
            }
            return '';
        };

        // Prepare data for Excel
        const excelData = allProjects.map((project) => {
            // Get edited data if available
            const edits = editedDataMap[project.projet._id] || {};

            // Use edited project name if available, otherwise use original
            const projectName = edits.projectName || project.projet.name_en || project.projet.name;

            // Use edited creator name if available, otherwise use original
            const creatorName = edits.creatorName || definitiveNames[project.projet._id] || '';

            // Use edited country if available (for espace projects), otherwise extract from address
            let country = '';
            if (project.projet.type === 'espace') {
                country = edits.country || getProjectCountry(project);
            }

            // Get fabricants list - show "CONFIDENTIEL" if communiquer_fabricants is "non"
            const fabricants = project.projet.communiquer_fabricants === 'non'
                ? 'CONFIDENTIEL'
                : getFabricantsList(project, edits);

            // Get distributeur and editeur (galerie) from project
            const distributeur = project.projet.distributeur?.trim() || '';
            const editeur = project.projet.editeur?.trim() || '';

            return {
                'Nom du projet': projectName,
                'Nom du projet (EN)': edits.projectName || project.projet.name_en || '',
                'Designer/Entreprise': creatorName,
                'Typologie': project.projet.typologie || 'Sans catégorie',
                'Pays': country,
                'Fabrication française': hasFabricationFrancaise(project) ? 'Oui' : 'Non',
                'Fabricants': fabricants,
                'Distributeur': distributeur,
                'Galerie/Éditeur': editeur
            };
        });

        // Create worksheet
        const ws = XLSX.utils.json_to_sheet(excelData);

        // Set column widths
        const wscols = [
            {wch: 40},  // Nom du projet
            {wch: 40},  // Nom du projet (EN)
            {wch: 40},  // Designer/Entreprise
            {wch: 20},  // Typologie
            {wch: 20},  // Pays
            {wch: 20},  // Fabrication française
            {wch: 60},  // Fabricants
            {wch: 30},  // Distributeur
            {wch: 30}   // Galerie/Éditeur
        ];
        ws['!cols'] = wscols;

        // Create workbook
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Sélection Finale FD100 2025');

        // Generate filename with current date
        const date = new Date().toISOString().split('T')[0];
        const filename = `FD100_2025_Selection_Finale_${date}.xlsx`;

        // Save file
        XLSX.writeFile(wb, filename);
    };

    const [exportingFabricants, setExportingFabricants] = useState(false);

    const exportFabricantsToExcel = async () => {
        if (!selection || !event) return;

        setExportingFabricants(true);

        try {
            const allProjects = [
                ...sortedTop91,
                ...(selection.ballotage9 || [])
            ];

            // Prepare projects data for server-side Excel generation (with images)
            const projectsData = allProjects.map((project, index) => {
                const edits = editedDataMap[project.projet._id] || {};
                const projectName = edits.projectName || project.projet.name_en || project.projet.name;
                const creatorName = getDisplayCreatorName(project);

                // Get image path for server-side embedding
                let imagePath = '';
                if (project.projet.medias && project.projet.medias.length > 0) {
                    const firstImage = project.projet.medias.find(media =>
                        media.type && media.type.includes('image')
                    );
                    if (firstImage && firstImage.path) {
                        imagePath = firstImage.path;
                    } else if (project.projet.medias[0]?.type?.includes('pdf')) {
                        const pdfMedia = project.projet.medias[0];
                        const filename = pdfMedia.path.split('/').pop();
                        imagePath = pdfMedia.path.replace(filename, 'firstpage_' + filename).replace('.pdf', '.png');
                    }
                }

                // Use edited fabricants if available, otherwise original
                const fabricants = edits.fabricants || project.projet.fabricants || '[]';

                return {
                    position: index + 1,
                    imagePath,
                    nomProjet: projectName,
                    nomProjetEn: project.projet.name_en || '',
                    designerEntreprise: creatorName,
                    typologie: project.projet.typologie || '',
                    typeProjet: project.projet.type || '',
                    fabricants: typeof fabricants === 'string' ? fabricants : JSON.stringify(fabricants)
                };
            });

            console.log(`Fabricants export: sending ${projectsData.length} projects to server`);

            const excelResponse = await api.exportFD100ProjectsExcel({
                eventId: event._id,
                projects: projectsData,
                language: 'fr',
                fabricantsOnly: true
            });

            // Download the blob
            const blob = new Blob([excelResponse.data], {
                type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
            });
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            const date = new Date().toISOString().split('T')[0];
            link.download = `FD100_2025_Fabricants_${date}.xlsx`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting fabricants:', error);
            alert('Erreur lors de l\'export. Veuillez réessayer.');
        }

        setExportingFabricants(false);
    };

    const exportSelectionToPDF = async () => {
        if (!selection || !event) return;
        
        try {
            setGeneratingPDF(true);
            
            // Combine all 100 projects from the final selection
            const allProjects = [
                ...selection.top91,
                ...selection.ballotage9
            ];
            
            // Get English category labels
            const tyoplogieEspaceFD100En = FD100MultiSelectOptions.tyoplogieEspaceFD100("en");
            const typologieObjetFD100En = FD100MultiSelectOptions.typologieObjetFD100("en");
            
            // Get category label in English for each project
            const getCategoryLabelEn = (typology) => {
                if (!typology) return 'Uncategorized';
                
                // Try to find in espace categories
                const espaceCategory = tyoplogieEspaceFD100En.find(cat => cat.value === typology);
                if (espaceCategory) return espaceCategory.label;
                
                // Try to find in objet categories
                const objetCategory = typologieObjetFD100En.find(cat => cat.value === typology);
                if (objetCategory) return objetCategory.label;
                
                return typology; // Return as is if not found
            };
            
            // Prepare projects for PDF
            const projectsForPDF = allProjects.map(project => {
                // Build the fiche candidat URL based on candidate_as_person_fd100_25
                const baseUrl = window.location.origin;
                let ficheCandidat;
                if (project.projet.candidate_as_person_fd100_25 === "oui") {
                    // Person profile - use base64 encoded email
                    ficheCandidat = `${baseUrl}/profile?id=${btoa(project.user.user.email)}`;
                } else {
                    // Company profile
                    ficheCandidat = project.user.company?._id 
                        ? `${baseUrl}/company?id=${project.user.company._id}`
                        : `${baseUrl}/profile?id=${btoa(project.user.user.email)}`; // Fallback to profile
                }
                
                // Build the fiche projet URL
                const ficheProjet = `${baseUrl}/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}&company_id=${project.user.company?._id || ''}&edit-mode=true`;
                
                // Get project image URL
                const projectImage = getProjectImage(project.projet);
                
                return {
                    project_name: project.projet.name,
                    project_name_en: project.projet.name_en || '',
                    company_or_designer_name: getDisplayCreatorName(project),
                    fiche_candidat: ficheCandidat,
                    fiche_projet: ficheProjet,
                    project_image: projectImage || null,
                    project_category: getCategoryLabelEn(project.projet.typologie), // Send English category label
                    fabrication_francaise: hasFabricationFrancaise(project),
                    project_address: project.projet.adresse || '' // Include project address
                };
            });

            projectsForPDF.length = 98; // Limit to 98 projects max because I didn't understand what Emmanuelle wanted

            console.log("Exporting PDF with projects:", projectsForPDF);
            
            const response = await api.exportFD100ProjectsWinning(event._id, projectsForPDF);
            
            // Create a blob from the response
            const blob = new Blob([response.data], { type: 'application/pdf' });
            
            // Create a download link
            const url = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `FD100_Selection_Finale_${new Date().toISOString().split('T')[0]}.pdf`);
            
            // Trigger download
            document.body.appendChild(link);
            link.click();
            
            // Cleanup
            link.parentNode.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Error exporting PDF:', error);
            alert('Erreur lors de l\'export PDF');
        } finally {
            setGeneratingPDF(false);
        }
    };

    //log all project ids in selection
    useEffect(() => {
        if (selection) {
            const allProjectIds = [
                ...selection.top91.map(p => p.projet._id),
                ...selection.ballotage9.map(p => p.projet._id)
            ];
            console.log("All selected project IDs:", allProjectIds);
        }
    }, [selection]);

    // Sort projects by votes (same order as FD100ProjectsInCompetition)
    const sortedTop91 = selection ? [...selection.top91].sort((a, b) => {
        const voteDiff = cumulNoteOfProj(b) - cumulNoteOfProj(a);
        if (voteDiff !== 0) return voteDiff;

        const mentionDiff = cumulMentionsForProj(b) - cumulMentionsForProj(a);
        if (mentionDiff !== 0) return mentionDiff;

        const departageDiff = departagePointsForProj(b) - departagePointsForProj(a);
        if (departageDiff !== 0) return departageDiff;

        // Sort by fabrication française
        return (hasFabricationFrancaise(b) ? 1 : 0) - (hasFabricationFrancaise(a) ? 1 : 0);
    }) : [];

    if (loading) {
        return <Spinner />;
    }

    if (!selection) {
        return (
            <Container>
                <BackButton to={`/admin/events/fd100projectsincompetition?eid=${event?._id}&ballotage=true`}>
                    ← Retour aux projets en ballotage
                </BackButton>
                
                <NoSelectionMessage>
                    <h3>Aucune sélection finale disponible</h3>
                    <p>
                        La sélection finale FD100 2025 n'a pas encore été créée.<br/>
                        Vous devez d'abord sélectionner 9 projets depuis la page des projets en ballotage.
                    </p>
                    <BackButton to={`/admin/events/fd100projectsincompetition?eid=${event?._id}&ballotage=true`}>
                        Aller aux projets en ballotage
                    </BackButton>
                </NoSelectionMessage>
            </Container>
        );
    }

    return (
        <Container>
            <BackButton to={`/admin/events/fd100projects?eid=${event?._id}`}>
                ← Retour aux projets en compétition
            </BackButton>

            <HeaderSection>
                <StatsInfo>
                    <div className="main-title">🏆 Sélection Finale FD100 2025</div>
                    <div className="event-info">{selection.eventTitle}</div>
                    <div className="selection-date">
                        Sélection validée le {new Date(selection.date).toLocaleDateString('fr-FR', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                            hour: '2-digit',
                            minute: '2-digit'
                        })}
                    </div>
                    <div style={{marginTop: '15px', fontSize: '18px', fontWeight: '700', color: '#2196f3'}}>
                        100 projets sélectionnés au total
                    </div>
                </StatsInfo>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    <ExportButton as={Link} to="/fd100kvtest" target="_blank" style={{ textDecoration: 'none' }}>
                        🖼️ Générer les Key Visuals
                    </ExportButton>
                    <ExportButton onClick={exportToExcel}>
                        📊 Exporter la sélection finale
                    </ExportButton>
                    <ExportButton
                        onClick={exportFabricantsToExcel}
                        disabled={exportingFabricants}
                        style={{
                            background: exportingFabricants
                                ? 'linear-gradient(135deg, #999, #666)'
                                : 'linear-gradient(135deg, #ff9800, #f57c00)',
                            cursor: exportingFabricants ? 'not-allowed' : 'pointer',
                            opacity: exportingFabricants ? 0.7 : 1
                        }}
                    >
                        {exportingFabricants ? '⏳ Export en cours...' : '🏭 Exporter les fabricants'}
                    </ExportButton>
                    <ExportButton
                        onClick={exportSelectionToPDF}
                        disabled={generatingPDF}
                        style={{
                            background: generatingPDF
                                ? 'linear-gradient(135deg, #999, #666)'
                                : 'linear-gradient(135deg, #4caf50, #45a049)',
                            cursor: generatingPDF ? 'not-allowed' : 'pointer',
                            opacity: generatingPDF ? 0.7 : 1
                        }}
                    >
                        {generatingPDF ? '⏳ Génération en cours...' : '📄 Exporter la sélection finale en PDF'}
                    </ExportButton>
                    <ExportButton
                        onClick={downloadAllImages}
                        disabled={downloadingImages || downloadingAllImages}
                        style={{
                            background: downloadingImages
                                ? 'linear-gradient(135deg, #999, #666)'
                                : 'linear-gradient(135deg, #9c27b0, #7b1fa2)',
                            cursor: downloadingImages ? 'not-allowed' : 'pointer',
                            opacity: downloadingImages ? 0.7 : 1
                        }}
                    >
                        {downloadingImages
                            ? '⏳ Génération en cours...'
                            : '🖼️ Télécharger les miniatures (ZIP)'}
                    </ExportButton>
                    <ExportButton
                        onClick={downloadAllImagesComplete}
                        disabled={downloadingImages || downloadingAllImages}
                        style={{
                            background: downloadingAllImages
                                ? 'linear-gradient(135deg, #999, #666)'
                                : 'linear-gradient(135deg, #e91e63, #c2185b)',
                            cursor: downloadingAllImages ? 'not-allowed' : 'pointer',
                            opacity: downloadingAllImages ? 0.7 : 1
                        }}
                    >
                        {downloadingAllImages
                            ? '⏳ Génération en cours...'
                            : '🖼️ Télécharger toutes les images (ZIP)'}
                    </ExportButton>
                    <ExportButton
                        onClick={downloadImagesWithCredits}
                        disabled={downloadingImages || downloadingAllImages || downloadingImagesWithCredits}
                        style={{
                            background: downloadingImagesWithCredits
                                ? 'linear-gradient(135deg, #999, #666)'
                                : 'linear-gradient(135deg, #ff5722, #e64a19)',
                            cursor: downloadingImagesWithCredits ? 'not-allowed' : 'pointer',
                            opacity: downloadingImagesWithCredits ? 0.7 : 1
                        }}
                    >
                        {downloadingImagesWithCredits
                            ? '⏳ Génération en cours...'
                            : '📷 Télécharger images + crédits (ZIP)'}
                    </ExportButton>
                </div>
            </HeaderSection>

            {/* Top 91 Projects
            <SectionTitle background="linear-gradient(135deg, #2196f3, #1976d2)">
                🥇 Top 91 - Projets sélectionnés par votes
            </SectionTitle> */}
            
            <ProjectGrid>
                {sortedTop91.map((project, index) => (
                    <ProjectCard key={index}>
                        <RankingBadge rank={index + 1}>#{index + 1}</RankingBadge>
                        <ProjectImage style={{ 
                            backgroundImage: getProjectImage(project.projet) ? `url(${getProjectImage(project.projet)})` : 'none' 
                        }} />
                        <CategoryBadge>{project.projet.typologie || 'Sans catégorie'}</CategoryBadge>
                        <ProjectName>
                            <span>{getDisplayProjectName(project)}</span>
                            {hasFabricationFrancaise(project) && <FabFrIndicator />}
                        </ProjectName>
                        <DesignerName>{getDisplayCreatorName(project)}</DesignerName>
                        <RatingsInfo>
                            <RatingItem>
                                <div className="label">Votes</div>
                                <div className="value">{cumulNoteOfProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Coups de cœur</div>
                                <div className="value">{cumulMentionsForProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Commentaires</div>
                                <div className="value">{commentairesForProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Départage</div>
                                <div className="value" style={{color: '#ff9800'}}>{departagePointsForProj(project)}</div>
                            </RatingItem>
                        </RatingsInfo>
                        <div>
                            <ViewButton
                                to={`/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}&company_id=${project.user.company?._id || ''}&edit-mode=true`}
                                target="_blank"
                            >
                                Voir la fiche projet
                            </ViewButton>
                            <ViewButton
                                style={{background: 'linear-gradient(135deg, #6c757d, #495057)'}}
                                to={project.user.company ? `/company?id=${project.user.company._id}` : `/profile?id=${project.user.user._id}`}
                                target="_blank"
                            >
                                Fiche agence
                            </ViewButton>
                        </div>
                    </ProjectCard>
                ))}
            </ProjectGrid>

            <SectionTitle background="linear-gradient(135deg, #ff9800, #f57c00)">
                🗳️ {(selection.ballotage9 ? selection.ballotage9.length : (selection.ballotageProjects ? selection.ballotageProjects.length : 0))} projet{(selection.ballotage9 ? selection.ballotage9.length : (selection.ballotageProjects ? selection.ballotageProjects.length : 0)) > 1 ? 's' : ''} sélectionné{(selection.ballotage9 ? selection.ballotage9.length : (selection.ballotageProjects ? selection.ballotageProjects.length : 0)) > 1 ? 's' : ''} depuis le ballotage
            </SectionTitle>
            
            <ProjectGrid>
                {((selection.ballotage9 ? selection.ballotage9 : (selection.ballotageProjects ? selection.ballotageProjects : []))
                    .slice() // copy array
                    .sort((a, b) => {
                        // Sort by cumul note, then coup de coeur, then departage points
                        const noteA = cumulNoteOfProj(a);
                        const noteB = cumulNoteOfProj(b);
                        if (noteB !== noteA) return noteB - noteA;
                        const coeurA = cumulMentionsForProj(a);
                        const coeurB = cumulMentionsForProj(b);
                        if (coeurB !== coeurA) return coeurB - coeurA;
                        // Use ratings to get departage points (jury2025_departage_point)
                        const departA = (() => {
                            const _ratings = getProjectRatings(a);
                            return _ratings.reduce((total, rating) => total + (rating.rating.jury2025_departage_point ? 1 : 0), 0);
                        })();
                        const departB = (() => {
                            const _ratings = getProjectRatings(b);
                            return _ratings.reduce((total, rating) => total + (rating.rating.jury2025_departage_point ? 1 : 0), 0);
                        })();
                        return departB - departA;
                    })
                ).map((project, index) => (
                    <ProjectCard key={index}>
                        <BallotageLabel>Ballotage #{index + 1}</BallotageLabel>
                        <RankingBadge rank={sortedTop91.length + index + 1}>
                            #{sortedTop91.length + index + 1}
                        </RankingBadge>
                        <ProjectImage style={{ 
                            backgroundImage: getProjectImage(project.projet) ? `url(${getProjectImage(project.projet)})` : 'none' 
                        }} />
                        <CategoryBadge>{project.projet.typologie || 'Sans catégorie'}</CategoryBadge>
                        <ProjectName>
                            <span>{getDisplayProjectName(project)}</span>
                            {hasFabricationFrancaise(project) && <FabFrIndicator />}
                        </ProjectName>
                        <DesignerName>{getDisplayCreatorName(project)}</DesignerName>
                        <RatingsInfo>
                            <RatingItem>
                                <div className="label">Votes</div>
                                <div className="value">{cumulNoteOfProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Coups de cœur</div>
                                <div className="value">{cumulMentionsForProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Commentaires</div>
                                <div className="value">{commentairesForProj(project)}</div>
                            </RatingItem>
                            <RatingItem>
                                <div className="label">Départage</div>
                                <div className="value" style={{color: '#ff9800'}}>{(() => {
                                    const _ratings = getProjectRatings(project);
                                    return _ratings.reduce((total, rating) => total + (rating.rating.jury2025_departage_point ? 1 : 0), 0);
                                })()}</div>
                            </RatingItem>
                        </RatingsInfo>
                        <div>
                            <ViewButton
                                to={`/admin/events/fdficheprojet?email=${project.user.user.email}&pid=${project.user.participation._id}&projid=${project.projet._id}&company_id=${project.user.company?._id || ''}&edit-mode=true`}
                                target="_blank"
                            >
                                Voir la fiche projet
                            </ViewButton>
                            <ViewButton
                                style={{background: 'linear-gradient(135deg, #6c757d, #495057)'}}
                                to={project.user.company ? `/company?id=${project.user.company._id}` : `/profile?id=${project.user.user._id}`}
                                target="_blank"
                            >
                                Fiche agence
                            </ViewButton>
                        </div>
                    </ProjectCard>
                ))}
            </ProjectGrid>
        </Container>
    );
};

export default FD100FinalSelection;